export default "__VITE_ASSET__DEvatNff__"